var AnnouncementTypeEnum;
(function (AnnouncementTypeEnum) {
    AnnouncementTypeEnum["NONE"] = "None";
    AnnouncementTypeEnum["MAINTENANCE"] = "Maintenance";
    AnnouncementTypeEnum["PRODUCTUPDATE"] = "ProductUpdate";
    AnnouncementTypeEnum["WEBINAR"] = "Webinar";
})(AnnouncementTypeEnum || (AnnouncementTypeEnum = {}));
export default AnnouncementTypeEnum;
